<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
  <div
    class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p (click)="navigateToReports()">Reports</p>
    <p onclick="history.back()">Officer Reports</p>
    <p>Daily Report</p>
  </div>

  <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363638] shadow-lg rounded-lg mt-5">
    <div class="flex flex-row items-center justify-end">
      <div class="flex flex-row items-center gap-4">
        <p class="text-[18px] font-normal text-[#000000] dark:text-white">Date :</p>
        <div class="relative w-48 mr-6">

          <app-custom-datepicker [selectedDate]="selectDate"
            (dateChange)="onDateChange($event)"></app-custom-datepicker>
        </div>
      </div>
    </div>

    <div class="flex flex-col items-center justify-center my-5">
      <p class="text-[18px] text-[#292929] dark:text-textDark font-normal">{{officerName}} - <span
          class="dark:text-white">{{empId}}</span></p>
      <p class="text-[16px] font-normal text-[#534E4E] mt-3 dark:text-textDark">On <span
          class="dark:text-white">{{selectDate}}</span></p>
    </div>

    <div *ngIf="!hasData"
      class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
      <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
      <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
    </div>

    <div *ngIf="hasData">
      <div *ngIf="!loadingChart; else loading">
        <div class="pt-16" id="chartContainer">
          <canvasjs-chart *ngIf="chartOptions" [options]="chartOptions"></canvasjs-chart>
        </div>
      </div>

      <ng-template #loading>
        <p>Loading chart...</p>
      </ng-template>

      <div class="w-full mt-8 rounded-lg">
        <table class="w-full border-collapse border dark:bg-[white] border-gray-300 rounded-lg">
          <thead>
            <tr class="bg-[#E4DCD3] dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] text-[#000000]">
              <th class="border border-[#828282] dark:border-[#202021] px-4 py-2">Crop Variety</th>
              <th class="border border-[#828282] dark:border-[#202021] px-4 py-2">Grade A</th>
              <th class="border border-[#828282] dark:border-[#202021] px-4 py-2">Grade B</th>
              <th class="border border-[#828282] dark:border-[#202021] px-4 py-2">Grade C</th>
              <th class="border border-[#828282] dark:border-[#202021] px-4 py-2">Total</th>
            </tr>
          </thead>
          <tbody class="border-[#828282] dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
            <tr *ngFor="let item of dailyReportArr">
              <td class="text-center dark:text-gray-300 border border-[#828282] dark:border-[#1D1D1F] px-4 py-2">
                {{item.varietyNameEnglish}}
              </td>
              <td class="text-center  dark:text-gray-300  border border-[#828282] dark:border-[#1D1D1F] px-4 py-2">
                {{item.gradeA | number: '1.2-2'}}kg</td>
              <td class="text-center dark:text-gray-300 border border-[#828282] dark:border-[#1D1D1F] px-4 py-2">
                {{item.gradeB | number: '1.2-2'}}kg</td>
              <td class="text-center dark:text-gray-300 border border-[#828282] dark:border-[#1D1D1F] px-4 py-2">
                {{item.gradeC | number: '1.2-2'}}kg</td>
              <td class="text-center dark:text-gray-300 border border-[#828282] dark:border-[#1D1D1F] px-4 py-2">
                {{item.total | number: '1.2-2'}}kg</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-center items-center mt-8">
        <button class="bg-[#415CFF] text-lg text-white rounded-lg shadow-lg px-4 py-2" (click)="downloadPDF2()">
          Download
        </button>
      </div>
    </div>

  </div>

</div>